'use strict';

ebCheckboxes.$inject = [];

function ebCheckboxes() {
    return {
        restrict: 'E',
        templateUrl: require('./ebCheckboxes.html'),
        scope: {
            title: '@',
            storageObj: '=',
            handler: '='
        }
    };
}

module.exports = ebCheckboxes;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebCheckboxesDirective.js
// module id = 38
// module chunks = 0